import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeSourceId: (value: string) => void;
}

const SourceIdField: React.FC<IProps> = ({ changeSourceId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterSourceId') },
			{
				validator(_, value) {
					if (!value || (value.length >= 1 && value.length <= 20)) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('theValueMustContainNumberOfCharacters', { value: '1-20' })));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeSourceId(onlyDigits);
			return onlyDigits;
		},
		[changeSourceId],
	);

	return (
		<FormInput
			testId="SourceIdField"
			name="sourceId"
			label="sourceIdLabel"
			maxLength={20}
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(SourceIdField);
